import { MpAreaSelectContent } from './MpAreaSelectContent';
export default MpAreaSelectContent;